import { useState, useEffect } from "react";

interface NavbarProps {
  onInspectionClick: () => void;
}

export default function Navbar({ onInspectionClick }: NavbarProps) {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <nav
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        scrolled ? "bg-[#0a0e1a] shadow-lg" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 md:px-8 flex items-center justify-between h-16 md:h-20">
        {/* Logo */}
        <a href="/" className="flex items-center">
          <img
            src="https://static.readdy.ai/image/61892072331720d5ae52870a50f3ccd8/7ae8d477771f73e998ed5d5ba3a2bcfc.png"
            alt="CLWizard Logo"
            className="h-10 md:h-12 w-auto object-contain"
          />
        </a>

        {/* Desktop Nav */}
        <div className="hidden md:flex items-center gap-6">
          <a
            href="tel:5617745120"
            className="flex items-center gap-2 text-white font-semibold text-base hover:text-[#4a7fa5] transition-colors whitespace-nowrap"
          >
            <span className="w-8 h-8 flex items-center justify-center">
              <i className="ri-phone-fill text-[#4a7fa5] text-lg"></i>
            </span>
            (561) 774-5120
          </a>
          <button
            onClick={onInspectionClick}
            className="bg-[#1a3a5c] hover:bg-[#0f2a45] text-white font-bold px-6 py-2.5 rounded-md transition-colors whitespace-nowrap text-sm"
          >
            Get a Free Inspection
          </button>
        </div>

        {/* Mobile hamburger */}
        <button
          className="md:hidden w-8 h-8 flex items-center justify-center text-white"
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <i className={`text-2xl ${menuOpen ? "ri-close-line" : "ri-menu-line"}`}></i>
        </button>
      </div>

      {/* Mobile menu */}
      {menuOpen && (
        <div className="md:hidden bg-[#0a0e1a] border-t border-white/10 px-4 py-4 flex flex-col gap-4">
          <a
            href="tel:5617745120"
            className="flex items-center gap-2 text-white font-semibold text-base whitespace-nowrap"
          >
            <span className="w-6 h-6 flex items-center justify-center">
              <i className="ri-phone-fill text-[#4a7fa5]"></i>
            </span>
            (561) 774-5120
          </a>
          <button
            onClick={() => { setMenuOpen(false); onInspectionClick(); }}
            className="bg-[#1a3a5c] text-white font-bold px-6 py-3 rounded-md whitespace-nowrap text-sm"
          >
            Get a Free Inspection
          </button>
        </div>
      )}
    </nav>
  );
}
